import { __assign } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo, useCallback } from 'react';
import { Card } from '@sravni/react-design-system';
import { Text, Link } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile, useAuthLoginLink } from '@sravni/react-utils';
import { useAnalytics } from '../../../../analytics/hooks.js';
import '../../../../analytics/context.js';
import { EVENT_TYPE } from '../../constants.js';
import { useSelectionCalculator } from '../../hooks.js';
import modules_5c7da1b7 from './Memo.module.scss.js';
import { trySravniLogin } from './sravni.login.js';

var Memo = function () {
    var isMobile = useIsMobile();
    var _a = useSelectionCalculator(), baseUrl = _a.baseUrl, formValues = _a.formValues, onEvent = _a.onEvent, eventFormValues = _a.eventFormValues;
    var amount = formValues.amount, period = formValues.period, purpose = formValues.purpose;
    var eventLabelPage = useAnalytics().eventLabelPage;
    var returnUrl = useMemo(function () {
        return "".concat(baseUrl, "/kredity/onlajn-zayavka-na-kredit/?amount=").concat(amount, "&period=").concat(period, "&purpose=").concat(purpose, "&skipLanding=true&after_calculator_auth=link");
    }, [amount, baseUrl, period, purpose]);
    var loginUrl = useAuthLoginLink({ returnUrl: returnUrl, isNewWindow: true }).href;
    var onClick = useCallback(function () {
        if (onEvent) {
            onEvent({
                type: EVENT_TYPE.CALCULATOR_BUTTON_CLICK,
                payload: {
                    label: 'Войдите',
                    page: eventLabelPage,
                },
            });
        }
        if (loginUrl) {
            trySravniLogin({
                loginUrl: loginUrl,
                onSuccess: function () {
                    if (onEvent) {
                        onEvent({
                            type: EVENT_TYPE.CALCULATOR_REDIRECT_TO_FORM,
                            payload: __assign(__assign({}, eventFormValues), { label: 'Войти Сравни', page: eventLabelPage }),
                        });
                    }
                    window.location.href = returnUrl;
                },
                onError: function () {
                    if (onEvent) {
                        onEvent({
                            type: EVENT_TYPE.CALCULATOR_AUTH_ERROR,
                            payload: __assign(__assign({}, eventFormValues), { label: 'Сравни', page: eventLabelPage }),
                        });
                    }
                },
            });
        }
    }, [loginUrl, returnUrl, eventLabelPage, eventFormValues, onEvent]);
    return (jsx(Card, { size: isMobile ? 16 : 24, className: modules_5c7da1b7.wrapper, color: "blue", children: jsxs(Text, { strong: true, children: ["\u0423\u0436\u0435 \u0431\u044B\u043B\u0438 \u043D\u0430 \u0421\u0440\u0430\u0432\u043D\u0438?", isMobile && jsx("br", {}), " ", jsx(Link, { onClick: onClick, children: "\u0412\u043E\u0439\u0434\u0438\u0442\u0435" }), " \u0438 \u043F\u043E\u0434\u0431\u043E\u0440 \u0431\u0443\u0434\u0435\u0442 \u0431\u044B\u0441\u0442\u0440\u0435\u0435"] }) }));
};

export { Memo };
//# sourceMappingURL=Memo.js.map
